/**
 * Resolve displayed form values without treating 0 (or false) as missing.
 * `||` fallbacks drop those values because they are falsy.
 */

export function isAbsentFieldValue(
  value: unknown,
): value is null | undefined {
  return value === null || value === undefined;
}

export function resolveFormFieldValue<T>(
  working: T | null | undefined,
  original: T | null | undefined,
  empty: T,
): T {
  if (!isAbsentFieldValue(working)) return working;
  if (!isAbsentFieldValue(original)) return original;
  return empty;
}

export function resolveFormOriginalValue<T>(
  original: T | null | undefined,
  empty: T,
): T {
  return isAbsentFieldValue(original) ? empty : original;
}

/** Parse a number input. Empty string becomes 0; the string "0" stays 0. */
export function parseNumberInputValue(raw: string): number {
  return raw === "" ? 0 : Number(raw);
}

/** Display a stored cell/input value; keep numeric 0 instead of coercing to "". */
export function displayFieldInputValue(value: unknown): string | number {
  if (value === null || value === undefined) return "";
  if (typeof value === "number" || typeof value === "string") return value;
  return String(value);
}

/** Read a field from a block record or record list. Numeric 0 is kept. */
export function getValueFromRecord(
  data: Record<string, unknown> | Record<string, unknown>[] | null,
  fieldHandle: string,
): unknown {
  if (!data) return null;
  if (Array.isArray(data)) {
    return data[0]?.[fieldHandle] ?? null;
  }
  return data[fieldHandle] ?? null;
}
